import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    data: { cardContentType: "" },
};

const paymentSlice = createSlice({
    name: "stripeDetails",
    initialState,
    reducers: {
        setCardContentType: (state, { payload }) => {
            state.data.cardContentType = payload;
        }
    },
});

export const { setCardContentType } = paymentSlice.actions;
export default paymentSlice;